import './Button.css';

/**
 * Shared button (HS-98 design system). Single source of truth for button styling
 * so panels/modals stop reinventing it with bespoke per-component classes.
 *
 *   variant: 'primary'   — main action (run / generate / save), cyan accent
 *            'secondary' — neutral default (the implicit default)
 *            'danger'    — destructive / cancel
 *            'ghost'     — low-emphasis, transparent
 *   size:    'md' (default) | 'sm'
 *   block:   true → full-width (width: 100%)
 *
 * Forwards onClick / type / disabled / title / aria-* etc. via {...rest}. A
 * caller-supplied `className` is appended, so a call site can still add layout
 * tweaks (e.g. a full-width utility) without overriding the variant styling.
 */
export default function Button({
  variant = 'secondary',
  size = 'md',
  block = false,
  className = '',
  type = 'button',
  children,
  ...rest
}) {
  const cls = [
    'btn',
    `btn--${variant}`,
    size === 'sm' && 'btn--sm',
    block && 'btn--block',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
